import React from 'react';
import * as Icon from 'react-bootstrap-icons';
import Colors from '../helpers/Colors';
import Config from '../../assets/config.json';
import Locale from '../../assets/languages';

class Municipalities extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			municipalities: [],
			order: Object.keys(Locale.MUNICIPALITIES.ORDERING)[0],
			show: false
		}
		this.scoreProp = false;
		this.scorePerc = false;
		this.colors = [];

		this.Init = this.Init.bind(this);
		this.Fetch = this.Fetch.bind(this);
		this.Search = this.Search.bind(this);
		this.Toggler = this.Toggler.bind(this);
		this.Colors = new Colors();
	}

	componentDidMount() {
		const colors1 = this.Colors.Gradient(Config.COLORS.LIGHT, Config.COLORS.MEDIUM, 51);
		const colors2 = this.Colors.Gradient(Config.COLORS.MEDIUM, Config.COLORS.DARK, 51);

		colors1.pop();
		this.colors = colors1.concat(colors2);
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.LoaderToggle
			&& typeof (this.props.LoaderToggle) === 'function')
			this.Init();
	}

	Init() {
		this.Fetch();
	}

	Fetch(e) {
		this.props.LoaderToggle(true, 'municipalities');
		const order = e ? e.currentTarget.value : this.state.order;

		switch (order) {
			default:
			case 'TOT_USERS':
				this.scoreProp = 'totUsers';
				this.scorePerc = 'percRelUsers';
				break;

			case 'TOT_AREA':
				this.scoreProp = 'totArea';
				this.scorePerc = 'percTotArea';
				break;

			case 'REL_AREA':
				this.scoreProp = 'relArea';
				this.scorePerc = 'percRelArea';
				break;

			case 'AVG_SCORE':
				this.scoreProp = 'avgScore';
				this.scorePerc = 'percAvgScore';
				break;
		}

		this.props.MapSetStyles(this.scorePerc);

		//

		fetch(Config.API.ENDPOINT,
			{
				method: 'POST',
				mode: 'cors',
				body: JSON.stringify({
					action: 'GetMunicipalities',
					token: Config.API.TOKEN,
					params: {
						order: order
					}
				})
			})
			.then(res => res.json())
			.then(
				(result) => {
					if (result.status) {
						result.results.forEach(m => {
							m.color = this.colors[Math.round(m[this.scorePerc])];
							m.show = true;
						});
						this.setState({
							municipalities: result.results,
							order: order
						});
						document.querySelector('[name="search"]').value = null;
					}
					this.props.LoaderToggle(false, 'municipalities');
				},
				(error) => {
					console.error(error);
				}
			)
	}

	Search(e) {
		if (this.state.municipalities.length > 0) {
			this.state.municipalities.forEach(m => {
				if (e.currentTarget.value.trim().length > 0)
					m.show = m.name.toLowerCase().indexOf(e.currentTarget.value.trim().toLowerCase()) !== -1
				else
					m.show = true;
			});
			this.setState({ municipalities: this.state.municipalities });
		}
	}

	Toggler(e) {
		this.setState({ show: !this.state.show });
	}

	render() {
		return <>
			<aside className={'sidebar' + (this.state.show ? ' show' : '') + (this.props.className ? ' ' + this.props.className : '')}>
				<div className="wrapper d-flex flex-column h-100">
					<div className="filters p-3">
						<div className="row">
							<div className="col-10 col-md-12">
								<div className="input-group mb-3">
									<input type="text" name="search" className="form-control form-control-custom-o-green-dark" placeholder={Locale.MUNICIPALITIES.FIND} onChange={this.Search} />
									<span className="input-group-text input-group-text-custom-o-green-dark"><Icon.Search /></span>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-4 col-md-6 col-lg-5 col-xl-4 small pt-2">
								{Locale.MUNICIPALITIES.SORT}:
							</div>
							<div className="col-8 col-md-6 col-lg-7 col-xl-8">
								<select name="order" className="form-select form-select-custom-o-green-dark" onChange={this.Fetch}>
									{Object.keys(Locale.MUNICIPALITIES.ORDERING).map((k, i) => {
										return <option key={i} value={k}>
											{Locale.MUNICIPALITIES.ORDERING[k]}
										</option>
									})}
								</select>
							</div>
						</div>
					</div>
					<div className="municipalities-header small">
						<ul className="municipalities list-unstyled my-0">
							<li className="d-flex flex-row">
								<span className="ranking">
									#
								</span>
								<span className="name flex-grow-1">
									{Locale.MUNICIPALITIES.MUNICIPALITY}
								</span>
								<span className="score">
									{Locale.MUNICIPALITIES.ORDERING[this.state.order]}
								</span>
							</li>
						</ul>
					</div>
					<div className="municipalities-content flex-grow-1 small">
						<ul className="municipalities list-unstyled">
							{this.state.municipalities.map((m, i) => {
								return <li key={m.id} className={'d-flex flex-row' + (m.show ? ' show' : '')}>
									<span className="ranking">
										{m.ranking}
									</span>
									<span className="name flex-grow-1">
										{m.name}
									</span>
									<span className="score">
										<span className="score-bg" style={{ backgroundColor: 'rgb(' + m.color.join(', ') + ')' }}></span>
										<span className={'score-number' + (Math.round(m[this.scorePerc]) >= 20 ? ' score-number-neg' : '')}>
											{Intl.NumberFormat(Config.LOCALE).format(m[this.scoreProp])}
										</span>
									</span>
								</li>
							})}
						</ul>
					</div>
					<div className="footer p-4">
						{/*
						<div className="row mb-4">
							<div className="col-12 d-grid">
								<a href="#" className="btn btn-lg btn-primary">{Locale.MUNICIPALITIES.SIGNUP}</a>
							</div>
						</div>
						*/}
						<div className="row">
							<div className="col-5 offset-1">
								<a href="https://rema1000.dk/" target="_blank" rel="noreferrer">
									<img src={process.env.PUBLIC_URL + '/images/rema1000v.svg'} className="img-fluid px-1" alt="" />
								</a>
							</div>
							<div className="col-5">
								<a href="https://www.dn.dk/" target="_blank" rel="noreferrer">
									<img src={process.env.PUBLIC_URL + '/images/danmarks-naturfredningsforening.svg'} className="img-fluid" alt="" />
								</a>
							</div>
						</div>
					</div>
				</div>
			</aside>
			<div className={'sidebar-toggler toggler' + (!this.state.show ? ' collapsed' : '')}>
				<div className="toggler-icon" onClick={this.Toggler}>
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
		</>
	}
}

export default Municipalities;